import gedcom from "refractor/gedcom";
export default gedcom;